import {constants} from '../../../redux/constants'
import {IWebState} from './reducers'

export const webActions = {
  setState: (state: IWebState) => ({
    type: constants.SET_WEB_STATE,
    state,
  }),
}
